export const amazonAssociateTag = 'bizaipro00-20';

export const shopCategories = [
  ['digitization', 'Digitization'],
  ['productivity', 'Productivity'],
  ['content', 'Content Creation'],
  ['mobility', 'Mobile Work'],
];

const amazonSearch = query =>
  `https://www.amazon.com/s?k=${encodeURIComponent(query)}&tag=${amazonAssociateTag}`;

export const starterProducts = [
  {
    slug: 'brother-ads-4300n-document-scanner',
    name: 'Brother ADS-4300N Professional Desktop Scanner',
    brand: 'Brother',
    model: 'ADS-4300N',
    category: 'digitization',
    summary: 'Networked duplex document scanner for offices that need shared paper-to-PDF workflows.',
    bestFor: ['Multi-page client files', 'Shared office scanning', 'Searchable PDF workflows'],
    caveats: ['Ethernet-focused model; check Wi-Fi needs before choosing', 'Cloud destinations require their own service accounts'],
    sourceUrl: 'https://www.brother-usa.com/p/desktop-scanners/ADS4300N',
    sourceLabel: 'Brother product page',
    amazonUrl: amazonSearch('Brother ADS-4300N Professional Desktop Scanner'),
    amazonLinkType: 'search',
    guideTitle: 'Brother ADS-4300N buying guide for small office scanning',
    workflowFit: 'Choose this when paper intake is a regular back-office task and multiple people need a reliable shared scanner rather than a personal USB-only device.',
    manufacturerNotes: ['Up to 40 ppm single and double-sided scanning is listed by Brother.', 'Brother lists an 80-page automatic document feeder and Ethernet networking.', 'Brother notes TWAIN, WIA, ISIS and SANE driver support.'],
  },
  {
    slug: 'epson-rapidreceipt-rr-600w',
    name: 'Epson RapidReceipt RR-600W Receipt and Document Scanner',
    brand: 'Epson',
    model: 'RR-600W',
    category: 'digitization',
    summary: 'Receipt and document scanner aimed at turning piles of paperwork into categorized financial data.',
    bestFor: ['Receipt backlogs', 'Bookkeeping handoff', 'QuickBooks or tax-prep workflows'],
    caveats: ['Financial integrations depend on your software and account setup', 'Verify receipt edition, region and included software before purchase'],
    sourceUrl: 'https://epson.com/p/B11B258202',
    sourceLabel: 'Epson product page',
    amazonUrl: amazonSearch('Epson RapidReceipt RR-600W scanner'),
    amazonLinkType: 'search',
    guideTitle: 'Epson RapidReceipt RR-600W buying guide for receipt-heavy businesses',
    workflowFit: 'Choose this when the bottleneck is receipt capture and bookkeeping prep, not just occasional document archiving.',
    manufacturerNotes: ['Epson positions the RR-600W for receipts and documents.', 'Epson says RapidReceipt can categorize data from invoices and receipts.', 'Epson references integrations with financial applications such as QuickBooks and TurboTax.'],
  },
  {
    slug: 'logitech-mx-keys-s-combo',
    name: 'Logitech MX Keys S Combo',
    brand: 'Logitech',
    model: 'MX Keys S Combo',
    category: 'productivity',
    summary: 'Keyboard, mouse and palm-rest bundle for desk setups where fast switching and comfort matter.',
    bestFor: ['Multi-device desks', 'Spreadsheet and admin work', 'Long writing sessions'],
    caveats: ['Check keyboard layout and operating-system support for your region', 'Not an AI product; it is workflow hardware'],
    sourceUrl: 'https://www.logitech.com/en-us/shop/c/combos',
    sourceLabel: 'Logitech combo listing',
    amazonUrl: amazonSearch('Logitech MX Keys S Combo'),
    amazonLinkType: 'search',
    guideTitle: 'Logitech MX Keys S Combo buying guide for productive desk work',
    workflowFit: 'Choose this when the productivity gain is fewer desk interruptions: better typing, precise pointing and switching across work devices.',
    manufacturerNotes: ['Logitech lists the MX Keys S Combo as including MX Keys S, MX Master 3S and MX Palm Rest.', 'Logitech describes the MX Keys S as built for comfortable, fast and fluid typing.', 'Logitech notes Logi Options+ customization on MX products.'],
  },
  {
    slug: 'logitech-mx-master-3s',
    name: 'Logitech MX Master 3S Wireless Mouse',
    brand: 'Logitech',
    model: 'MX Master 3S',
    category: 'productivity',
    summary: 'Customizable productivity mouse for repeated creative, browser and office actions.',
    bestFor: ['Design and editing shortcuts', 'Large spreadsheets', 'Multi-app workflows'],
    caveats: ['Comfort is hand-size dependent', 'Customization depends on installing supported Logitech software'],
    sourceUrl: 'https://www.logitech.com/en-us/shop/p/mx-master-3s',
    sourceLabel: 'Logitech product page',
    amazonUrl: amazonSearch('Logitech MX Master 3S wireless mouse'),
    amazonLinkType: 'search',
    guideTitle: 'Logitech MX Master 3S buying guide for repeatable office shortcuts',
    workflowFit: 'Choose this when mouse shortcuts and precise scrolling can reduce repetitive work across creative, admin and browser tasks.',
    manufacturerNotes: ['Logitech describes the MX Master 3S as customizable in Logi Options+.', 'Logitech lists an 8K optical sensor for the MX Master 3S.', 'Logitech positions the product for advanced productivity workflows.'],
  },
  {
    slug: 'logitech-brio-4k-webcam',
    name: 'Logitech Brio 4K Webcam',
    brand: 'Logitech',
    model: 'Brio 4K',
    category: 'content',
    summary: 'Business webcam for sharper video calls, webinars and recorded explainers.',
    bestFor: ['Client meetings', 'Webinars', 'Course and explainer recording'],
    caveats: ['Video quality still depends on lighting and bandwidth', 'Confirm exact Brio variant before checkout'],
    sourceUrl: 'https://www.logitech.com/en-us/shop/p/brio4kwebcam',
    sourceLabel: 'Logitech product page',
    amazonUrl: amazonSearch('Logitech Brio 4K webcam'),
    amazonLinkType: 'search',
    guideTitle: 'Logitech Brio 4K buying guide for client-facing video',
    workflowFit: 'Choose this when the business case is clearer calls and reusable video content rather than a full camera rig.',
    manufacturerNotes: ['Logitech markets Brio 4K for upgraded video meetings.', 'Logitech describes Brio as a professional 4K business webcam.', 'Logitech documentation references Windows Hello support on Brio.'],
  },
  {
    slug: 'rode-nt-usb-plus',
    name: 'Rode NT-USB+ Professional USB Microphone',
    brand: 'Rode',
    model: 'NT-USB+',
    category: 'content',
    summary: 'USB microphone for podcasts, voiceovers, livestreams and cleaner remote-work audio.',
    bestFor: ['Voiceover recording', 'Podcast interviews', 'Webinar audio'],
    caveats: ['Room treatment and mic placement still matter', 'Use the correct USB-C cable and app support for your device'],
    sourceUrl: 'https://rode.com/en-us/products/nt-usb-plus',
    sourceLabel: 'Rode product page',
    amazonUrl: amazonSearch('Rode NT-USB+ professional USB microphone'),
    amazonLinkType: 'search',
    guideTitle: 'Rode NT-USB+ buying guide for small business audio',
    workflowFit: 'Choose this when spoken content is part of the business and you need a simple USB setup before investing in an audio interface.',
    manufacturerNotes: ['Rode describes the NT-USB+ as a professional USB microphone.', 'Rode lists a studio-grade condenser capsule with a cardioid pickup pattern.', 'Rode says the microphone works for vocals, voice-overs, guitars, podcasts and streaming.'],
  },
  {
    slug: 'elgato-stream-deck-mk2',
    name: 'Elgato Stream Deck MK.2',
    brand: 'Elgato',
    model: 'Stream Deck MK.2',
    category: 'content',
    summary: 'Programmable key controller for live sessions, meetings and repeatable production actions.',
    bestFor: ['Webinar controls', 'Content production shortcuts', 'Meeting mute/camera actions'],
    caveats: ['Value depends on building useful profiles', 'Check software compatibility for your operating system and apps'],
    sourceUrl: 'https://www.elgato.com/us/en/p/stream-deck',
    sourceLabel: 'Elgato product page',
    amazonUrl: amazonSearch('Elgato Stream Deck MK.2'),
    amazonLinkType: 'search',
    guideTitle: 'Elgato Stream Deck MK.2 buying guide for repeatable production workflows',
    workflowFit: 'Choose this when repeated actions during calls, recording or streaming are slowing the operator down.',
    manufacturerNotes: ['Elgato describes Stream Deck as a customizable control surface.', 'Elgato references official meeting controls through plugins such as Zoom.', 'Elgato provides SDK, documentation and tools for custom actions.'],
  },
  {
    slug: 'elgato-key-light-air-mk2',
    name: 'Elgato Key Light Air MK.2',
    brand: 'Elgato',
    model: 'Key Light Air MK.2',
    category: 'content',
    summary: 'Compact LED panel for better desk video lighting and small creator setups.',
    bestFor: ['Video calls', 'Recorded tutorials', 'Small desk studios'],
    caveats: ['Power source affects brightness', 'The light-only option may not include every mounting accessory'],
    sourceUrl: 'https://www.elgato.com/us/en/p/key-light-air-light-only',
    sourceLabel: 'Elgato product page',
    amazonUrl: amazonSearch('Elgato Key Light Air MK.2'),
    amazonLinkType: 'search',
    guideTitle: 'Elgato Key Light Air MK.2 buying guide for better desk video',
    workflowFit: 'Choose this when the webcam is acceptable but the image looks weak because the desk lighting is inconsistent.',
    manufacturerNotes: ['Elgato lists up to 2100 lumens depending on power source.', 'Elgato lists a 2900-7000 K color range.', 'Elgato notes USB, Bluetooth or Wi-Fi control options.'],
  },
  {
    slug: 'anker-737-power-bank-powercore-24k',
    name: 'Anker 737 Power Bank (PowerCore 24K)',
    brand: 'Anker',
    model: '737 Power Bank',
    category: 'mobility',
    summary: 'High-capacity portable power bank for laptop-and-phone work away from the desk.',
    bestFor: ['Travel workdays', 'Events and booths', 'Backup power for mobile teams'],
    caveats: ['Airline and device rules vary; verify before travel', 'Cable and charger capability affect real charging speed'],
    sourceUrl: 'https://www.anker.com/products/a1289',
    sourceLabel: 'Anker product page',
    amazonUrl: amazonSearch('Anker 737 Power Bank PowerCore 24K'),
    amazonLinkType: 'search',
    guideTitle: 'Anker 737 Power Bank buying guide for mobile business work',
    workflowFit: 'Choose this when laptops, tablets and phones need dependable backup power during travel, events or client visits.',
    manufacturerNotes: ['Anker lists a 24,000 mAh total capacity.', 'Anker lists two USB-C ports and one USB-A port.', 'Anker lists up to 140 W maximum total output.'],
  },
  {
    slug: 'sandisk-extreme-portable-ssd',
    name: 'SanDisk Extreme Portable SSD',
    brand: 'SanDisk',
    model: 'Extreme Portable SSD',
    category: 'mobility',
    summary: 'Portable SSD for moving project files, local media backups and field content work.',
    bestFor: ['Video project handoff', 'Photo and design backups', 'Portable client archives'],
    caveats: ['Confirm generation, capacity and speed rating before purchase', 'Backups still need a second copy and access-control plan'],
    sourceUrl: 'https://documents.sandisk.com/content/dam/asset-library/en_us/assets/public/sandisk/product/internal-drives/extreme-usb-3-1-ssd/data-sheet-extreme-usb-3-1-ssd.pdf',
    sourceLabel: 'SanDisk data sheet',
    amazonUrl: amazonSearch('SanDisk Extreme Portable SSD'),
    amazonLinkType: 'search',
    guideTitle: 'SanDisk Extreme Portable SSD buying guide for portable project storage',
    workflowFit: 'Choose this when the team needs a compact local drive for media, design files or client archive transfers.',
    manufacturerNotes: ['SanDisk documentation lists capacities up to 2TB for the Extreme Portable SSD line referenced.', 'The data sheet describes high-speed transfers for photos and videos.', 'The product is portable storage, not cloud backup or AI hardware.'],
  },
];

export function shopCategoryLabel(slug) {
  return shopCategories.find(([key]) => key === slug)?.[1] || 'Shop';
}

export function shopSearchLink(product) {
  return product.amazonUrl || amazonSearch(`${product.brand} ${product.model}`);
}
